import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const QuickQuote = [
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.WELCOME.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/welcome/welcome.module').then(m => m.WelcomePageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.INSURANCE_HOLDER_DATA.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/insurance-holder-data/insurance-holder-data.module').then(m => m.InsuranceHolderDataPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.VEHICLE_SELECTION_TYPE.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/vehicle-selection-type/vehicle-selection-type.module').then(
        m => m.VehicleSelectionTypePageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.VEHICLE_SELECTION.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/vehicle-selection/vehicle-selection.module').then(
        m => m.VehicleSelectionPageModule
      ),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.CHOOSE_YOUR_CAR.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () =>
      import('@pages/vehicle-information/chose-your-car/chose-your-car.module').then(m => m.ChoseYourCarPageModule),
    canActivate: [NavigationGuard],
  },
  {
    path: RoutePaths.QUICK_QUOTE.QUICK_QUOTE.OFFER.route,
    title: 'TITLE.FULL_QUOTE',
    loadChildren: () => import('@pages/offer-qq/offer-qq.module').then(m => m.OfferQqPageModule),
    canActivate: [NavigationGuard],
  },
];
